

















































































































































import mixins from 'vue-typed-mixins'
import PMNMixin from './PMN-BiobankMixin'
import PMNDatatableMixin from '../../PMNDatatableMixin'
import { PMNDemande_Statut } from '@/domain/PMNDemande_Statut'

export default mixins(PMNMixin, PMNDatatableMixin).extend({
    components: {
        DialogMail: () => import('../../../layout/components/DialogMail.vue'),
    },
    data() {
        return {
            menusDates: [],
            panels: 0,
            headers: this.isMobileDevice()
                ? [
                      { text: 'Client', value: 'codeClient' },
                      { text: 'Statut', value: 'statut' },
                  ]
                : [
                      { text: 'Client', value: 'codeClient' },
                      { text: 'Date de création', value: 'dateCreation' },
                      { text: 'Statut', value: 'statut' },
                      { text: 'Modification du statut', value: 'lastUserTraitement' },
                  ],
            options: { sortBy: ['dateCreation'], sortDesc: [false] },
            listeStatutsDisponibles: [PMNDemande_Statut.EnCoursRedaction, PMNDemande_Statut.Envoyee, PMNDemande_Statut.EnCoursDeTraitement, PMNDemande_Statut.Acceptee, PMNDemande_Statut.Refusee],
        }
    },
    methods: {
        onCompanyChange() {
            this.getAllDemandePMN()
        },
    },
})
